/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdimonitorZbfrloc.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edimonitor-zbfrloc";

export class AutogenModelEdimonitorZbfrloc<RowType extends ModelRow> extends Endpoint<RowType, RowEdimonitorZbfrlocFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdimonitorZbfrloc extends ModelRow<RowEdimonitorZbfrlocFields> {
	constructor(values?: Partial<RowEdimonitorZbfrlocFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdimonitorZbfrlocFields {
	company_id: string;
	directory_location: string;
}

